A<template>
	<div class="baseBody relative">
		<div class="backBtn text-white" style="cursor: pointer;"  @click="goBack" >返回</div>
		<div class="dateWeek">
			<DynamicDate></DynamicDate>
		</div>
		<div class="topHead flex justify-between">
			<div class="leftHead"></div>
			<div class="midHead">{{provinceName}}招商地图</div>
			<div class="rightHead"></div>

		</div>

		<div class="leftProgram">
			<dv-border-box-12>
				<div style="padding:10px 0 15px 0;box-sizing: border-box">
					<div class="base-font-18 text-bold text-bold text-white text-center" style="padding:20px 0;">{{showName}}</div>
					<div style="padding:5px 20px;box-sizing: border-box;">
            <el-input  prefix-icon="el-icon-search" @input="getProjectList" class="input-with-select" v-model="keyword" placeholder="请输入项目名称">
            </el-input>
          </div>
					<div style="width:100%;height:calc(70vh - 250px);padding:0 20px 30px 20px;box-sizing: border-box;background: rgba(0, 142, 255, 0.05);border-radius:16px; overflow-y: auto;">
						<div @click="showItem(index)" class="proItem text-white margin-top-10" v-for="(item,index) in xmList" :key="index">{{item.name}}</div>
					</div>
				</div>
			</dv-border-box-12>
		</div>
		<div id="mainSf" style="padding-left: 10vw;box-sizing: border-box"></div>

		<el-dialog :visible.sync="dialogTableVisible" width="50%" customClass="mapTcStyle">
			<template v-if="dialogTableVisible">
				<dv-border-box-10 :color="['#064a80', '#01e3eb']" title="dv-border-box-11">
					<div
						style="box-sizing: border-box;padding:5px;background: #051b35;box-shadow:0 0 30px inset #064a80;border-radius:60px;">
						<div class="tcNeiBox" style="width:100%;height:450px;border-radius:20px;">
							<div class="text-center tcNeiTitle text-white">{{xmInfo.name}}</div>
							<div style="padding:15px 25px 5px 25px;box-sizing:border-box;">
								<div class="textInfo gdt " v-html="xmInfo.description">

								</div>
							</div>
              <div v-if="showJumpList!=null && showJumpList.length>0">
                <div v-if="xmInfo.recommendShow==1" class="text-white tcNeiTitle1" @click="dialogTable2Visible=true" style="margin-bottom: 30px;margin-left: 25px;float: left">拟推介项目</div>

                <div v-for="(item,index) in showJumpList" :key="index" class="text-white tcNeiTitle1"  style="margin-bottom: 30px;margin-left: 25px;float: left">
                  <a :href="item.url" class="tcNeiTitle1" target="_blank"> {{item.name}}</a>
                </div>

              </div>
						</div>


					</div>

				</dv-border-box-10>
			</template>
		</el-dialog>

    <el-dialog :visible.sync="dialogTable2Visible" width="70%" customClass="mapTcStyle">
      <template v-if="dialogTable2Visible">
        <dv-border-box-10 :color="['#064a80', '#01e3eb']" title="dv-border-box-11">
          <div
              style="box-sizing: border-box;padding:5px;background: #051b35;box-shadow:0 0 30px inset #064a80;border-radius:60px;">
            <div class="tcNeiBox" style="width:100%;height:500px;border-radius:20px;">
              <div class="text-center tcNeiTitle text-white">拟推介项目</div>
              <div style="padding:15px 25px;box-sizing:border-box;">
                <div class="textInfo gdt " v-html="xmInfo.recommendContent">

                </div>
              </div>
            </div>
          </div>

        </dv-border-box-10>
      </template>
    </el-dialog>

	</div>
</template>

<script>
	import DynamicDate from "../../components/dynamicDate/index.vue";
	// import router from '../../router';
  import {
    getProjectList,
    selectCityNum
  } from "@/api/api"
	export default {
		components: {
			DynamicDate,
		},
		data() {
			return {
        dialogTable2Visible:false,
				dialogTableVisible:false,
				showSfZszyL: [],
        posMap:{one:{x:0,y:0},two:{x:0,y:0},three:{x:0,y:0},four:{x:0,y:0}},
        cityList:[],
				xmList:[],
				xmInfo:{},
				city:'',
        cityName:'',
				provinceName:'',
        showName:'',
        keyword:'',
        showJumpList:[{name:'文旅康养',url:'http://www.baidu.com'},{name:'商务贸易',url:'http://www.baidu.com'}]
			}
		},
		mounted() {

			this.city=this.$route.query.city
      this.provinceName=this.$route.query.name;
			// if(this.$route.query.name.indexOf('省')==-1){
			// 	this.provinceName=this.$route.query.name+'省'
			// }
			// else{
			// 	this.provinceName=this.$route.query.name
			// }
			
			this.selectCityNum();
      this.getProjectList();
		},
		methods: {
      jumpUlr(index){
        let obj=this.showJumpList[index];
        window.location.href=obj.url;
      },
      showItem(index){
        this.xmInfo=this.xmList[index];
        this.showJumpList=[];
        console.log("==========1===="+this.xmInfo.recommendUrl);
        if(this.xmInfo.recommendUrl!=null && this.xmInfo.recommendUrl!="" && this.xmInfo.recommendUrl!=undefined){
          let list=this.xmInfo.recommendUrl.split("&");
          console.log("==========1-1===="+list);
          if(list!=null && list.length>0){
            list.forEach(obj=>{
              console.log("==========2===="+obj);
              let c=obj.split("#");
              if(c!=null&&c.length==2){
                console.log("==========3===="+c[0]+";"+c[1]);
                this.showJumpList.push({name:c[0],url:c[1]});
              }
            })
          }
        }

        this.dialogTableVisible=true
      },
			goBack(){
				this.$router.go(-1)
			},
			initMap() {
				let _self=this
				// let myChart = this.$echarts.init(document.getElementById("main"));
				
				 let mapDiv = document.getElementById('mainSf')
				      let myChartSf = _self.$echarts.init(mapDiv)
				      let city = _self.city
				      //动态引入省份json文件
				      _self.cityJson = require(`echarts/map/json/province/${city}.json`)
					  // con
				      _self.$echarts.registerMap(_self.city, _self.cityJson, {})
				
				// 地图：世界地图，中国地图，省份地图，市区地图
				// this.$echarts.registerMap("china", china);

        var option={
          // 背景色
          // backgroundColor: "rgb(121,145,200)",
          // 配置项(组件)
          geo: {
            map:_self.city,
            // 地图的长宽比例
            aspectScale: 0.75,
            // 图层
            zoom: 1.1,
            // 样式
            itemStyle: {
              normal: {
                borderColor: "#80c4dc",
                borderWidth:3,
                areaColor: 'rgba(7,34,124,0.8)',
                fontWeightL: 700,
                shadowColor: 'rgba(19, 59,165, 1)',
                shadowOffsetX: -2,
                shadowOffsetY: 2,
                shadowBlur: 10
              },
              emphasis: {
                areaColor: '#389BB7',
                borderWidth: 0
              },
            },

            region: [{
              name: "南海诸岛",
              itemStyle: {
                opacity: 0,
              },
            }, ],
          },
          series: [
            // 配置地图相关的数据参数
            {
              type: "map",
              // symbol: 'pin', //气泡
              label: {
                normal: {
                  // 显示文字
                  show: true,
                  textStyle: {
                    color: "#1DE9B6",
                  },

                },
                emphasis: {
                  textStyle: {
                    color: "rgb(183,185,14)",
                  },
                },
              },
              data: _self.showData,

              // 图层
              zoom: 1.1,
              map:_self.city,
              itemStyle: {
                normal: {
                  areaColor: {
                    colorStops: [{
                      offset: 0,
                      color: "rgb(5,108,236)"
                    },
                      {
                        offset: 1,
                        color: "rgb(5,41,134)"
                      },
                    ],
                  },
                  borderColor: '#fff',
                  fontWeightL: 700,
                  borderWidth: 1,
                },
                // 高亮效果
                emphasis: {
                  areaColor: "rgb(46,229,206)",
                  borderWidth: 0.1,
                },
              },
            },
            // 区域散点图
            {
              type: 'effectScatter',
              coordinateSystem: 'geo',
              zlevel: 2,
              symbolSize: 10,
              rippleEffect: { //坐标点动画
                period: 3,
                scale: 5,
                brushType: 'fill'
              },
              label: {
                normal: {
                  show: false,
                  // position: 'right',
                  // formatter: '{b}',
                  // color: '#b3e2f2',
                  // fontWeight: 'bold',
                  // fontSize: 16
                }
              },
              data:_self.showSfZszyL,
              itemStyle: { //坐标点颜色
                normal: {
                  show: true,
                  color: '#ff8003',
                  shadowBlur: 20,
                  shadowColor: '#fff'
                },
                emphasis: {
                  areaColor: '#f00'
                }
              }
            },
            {
              type: 'lines',
              zlevel: 3,
              symbol: 'circle',
              symbolSize: [5, 5],
              color: '#ff8003',
              opacity: 1,
              label: {
                show: true,
                padding: [10, 20],
                color: '#fff',
                backgroundColor: '#1a3961',
                borderColor: '#aee9fb',
                borderWidth: 1,
                borderRadius: 6,
                formatter(params) {
                  let arr = [params.name];
                  // return arr.join('\n');
                  return arr
                },
                textStyle: {
                  align: 'left',
                  lineHeight:20,
                  fontSize:16
                }
              },
              lineStyle: {
                type: 'solid',
                color: '#fff',
                width: 0.5,
                opacity: 1
              },
              data: _self.showSfZszyL
            }
          ],
        };
        if(city=='hainan'){
          option.series[0].center = [109.844902, 19.0392];
          option.series[0].layoutCenter = ['35%', '50%'];
          option.series[0].layoutSize = "500%";
        } else { //非显示海南时，将设置的参数恢复默认值
          option.series[0].center = undefined;
          option.series[0].layoutCenter = undefined;
          option.series[0].layoutSize = undefined;
        }
				myChartSf.setOption(option,true);
				window.addEventListener('resize', function () {
				     myChartSf.echarts.resize();
				     })
				myChartSf.on("click", function(params) { //点击事件
			
					if (params.componentSubType == "lines") {
						// _self.xmList.forEach(function(item){
						// 	if(params.name==item.name){
						// 		_self.xmInfo=item
						// 	}
						// })
            // eslint-disable-next-line no-debugger
            _self.cityName=params.data.cityName;
            _self.getProjectList();
					
					} else if (params.componentSubType == "effectScatter") {
						
						console.log('进入下个城市', params)
					}
					console.log(_self.xmInfo,1111)
				});

			},
      getProjectList() {
        if(this.cityName!=null && this.cityName!='' && this.cityName!=undefined){
          this.showName=this.cityName;
        }else{
          this.cityName="";
          this.showName=this.provinceName;
        }
        let _self=this
        getProjectList(1,_self.provinceName,this.cityName,_self.keyword).then(res => {
          _self.xmList=res.data;
        })
      },
      selectCityNum() {
        let _self=this
        selectCityNum({type:1,provinceName:_self.provinceName}).then(res => {
          _self.cityList=res.data
          res.data.forEach(function(item){
            let longitude=item.latitude;
            let latitude=item.longitude;
            let r = _self.getDeltaPos(longitude,latitude);
            _self.showSfZszyL.push({
              "name": item.name+"项目:"+item.num,
              "cityName":item.name,
              "value": [longitude*1,latitude*1],
              "coords": [
                [longitude*1,latitude*1],
                [r.x,r.y]
              ]
            })

          })
          _self.initMap()
        })
      },
      getDeltaPos(x,y){
        var oneMapList={x:[],y:[]};
        //方块一
        if(this.city=="beijing" ){
          for(let ok=0.5;ok>0;ok=ok-0.13){
            oneMapList.y.push(y*1+ok);
            oneMapList.y.push(y*1-ok);
          }
          for (let m=0.1;m<2.2;m=m+0.15){
            oneMapList.x.push(x*1+m);
            oneMapList.x.push(x*1-m);
          }
        }else if( this.city=="shanghai"){
          for(let ok=0.36;ok>0;ok=ok-0.13){
            oneMapList.y.push(y*1+ok);
            oneMapList.y.push(y*1-ok);
          }
          for (let m=0.1;m<1.8;m=m+0.15){
            oneMapList.x.push(x*1+m);
            oneMapList.x.push(x*1-m);
          }
        }else if( this.city=="hebei"||this.city=="tianjin"){
          for(let ok=0.36;ok>0;ok=ok-0.13){
            oneMapList.y.push(y*1+ok);
            oneMapList.y.push(y*1-ok);
          }
          for (let m=0.4;m<4.8;m=m+0.35){
            oneMapList.x.push(x*1+m);
            oneMapList.x.push(x*1-m);
          }
        }else if(this.city=="shanxi1"){
          for(let ok=1.2;ok>0;ok=ok-0.33){
            oneMapList.y.push(y*1+ok);
            oneMapList.y.push(y*1-ok);
          }
          for (let m=0.1;m<2.2;m=m+0.15){
            oneMapList.x.push(x*1+m);
            oneMapList.x.push(x*1-m);
          }
        }else if(this.city=="xianggang"){
          for(let ok=0.1;ok>0;ok=ok-0.03){
            oneMapList.y.push(y*1+ok);
            oneMapList.y.push(y*1-ok);
          }
          for (let m=0.1;m<2.2;m=m+0.15){
            oneMapList.x.push(x*1+m);
            oneMapList.x.push(x*1-m);
          }
        }else if(this.city=="hainan"){
          for(let ok=8.2;ok>0;ok=ok-2.3){
            oneMapList.y.push(y*1-ok);
          }
          for (let m=1;m<6.2;m=m+1.45){
            oneMapList.x.push(x*1+m);
            oneMapList.x.push(x*1-m);
          }
        }else if(this.city=="yunnan"){
          for(let ok=2.2;ok>0;ok=ok-0.2){
            oneMapList.y.push(y*1+ok);
            oneMapList.y.push(y*1-ok);
          }
          for (let m=1;m<10.2;m=m+1.85){
            oneMapList.x.push(x*1+m);
            oneMapList.x.push(x*1-m);
          }
        }else if(this.city=="zhejiang"){
          for(let ok=0.8;ok>0;ok=ok-0.2){
            oneMapList.y.push(y*1+ok);
            oneMapList.y.push(y*1-ok);
          }
          for (let m=1;m<5.2;m=m+0.85){
            oneMapList.x.push(x*1+m);
            oneMapList.x.push(x*1-m);
          }
        }else if(this.city=="jiangsu"){
          for(let ok=0.8;ok>0;ok=ok-0.2){
            oneMapList.y.push(y*1+ok);
            oneMapList.y.push(y*1-ok);
          }
          for (let m=1;m<4.2;m=m+0.85){
            oneMapList.x.push(x*1+m);
            oneMapList.x.push(x*1-m);
          }
        }else if(this.city=="anhui"){
          for(let ok=2.2;ok>0;ok=ok-0.53){
            oneMapList.y.push(y*1-ok);
          }
          for (let m=1;m<4.2;m=m+1.45){
            oneMapList.x.push(x*1+m);
            oneMapList.x.push(x*1-m);
          }
        }else if(this.city=="guangdong"){
          for(let ok=1.2;ok>0;ok=ok-0.13){
            oneMapList.y.push(y*1+ok);
            oneMapList.y.push(y*1-ok);
          }
          for (let m=1.1;m<6.2;m=m+0.18){
            oneMapList.x.push(x*1+m);
            oneMapList.x.push(x*1-m);
          }
        }else{
          for(var ok=1.2;ok>0;ok=ok-0.23){
            oneMapList.y.push(y*1+ok);
            oneMapList.y.push(y*1-ok);
          }
          for (var m=0.1;m<1.2;m=m+0.1){
            oneMapList.x.push(x*1+m);
            oneMapList.x.push(x*1-m);
          }
        }


        x=oneMapList.x[this.posMap.one.x];
        y=oneMapList.y[this.posMap.one.y];
        console.log("oneMapList:"+x+";"+y);
        this.posMap.one.x++;
        if(this.posMap.one.x>=oneMapList.x.length){
          this.posMap.one.x=0;
        }
        this.posMap.one.y++;
        if(this.posMap.one.y>=oneMapList.y.length){
          this.posMap.one.y=0;
        }
        return {x:x,y:y};
      }
		}
	}
</script>

<style>
	.leftProgram{width:18vw;position: fixed;left:20px;top:calc(15vh + 90px);box-sizing: border-box;z-index: 999999;}
	.el-input__inner{background:rgba(5,75,186,0.2);border:2px solid rgba(5,75,186,0.9) ;}
	.leftProgram .proItem{width:100%;padding:5rpx;box-sizing: border-box;background: rgba(0,180,255,0.05);padding:15px;font-size:15px;font-weight: bold;color:#9ddbff;
	border:1px solid #054bba;box-shadow:0 0 20px #054bba inset;border-radius:6px;
	}
	.leftProgram .proItem:hover{background: #054bba;color:#FFFFFF;cursor:pointer;}
	/*定义滚动条高宽及背景
	 高宽分别对应横竖滚动条的尺寸*/
	    ::-webkit-scrollbar {
	        width: 8px;
	        height: 8px;
	        background-color: rgba(0,180,255,0.05);
	    }
	
	    /*定义滚动条轨道
	 内阴影+圆角*/
	    ::-webkit-scrollbar-track
	    {
	        -webkit-box-shadow:inset 0 0 6px rgba(0,180,255,0.2);
	        border-radius:10px;
	        background-color:rgba(0,180,255,0.05);
	    }
	    /*定义滑块
	     内阴影+圆角*/
	    ::-webkit-scrollbar-thumb
	    {
	        border-radius:10px;
	        -webkit-box-shadow:inset 0 0 6px rgba(0,180,255,0.2);
	        background-color: rgba(0,180,255,0.7);
	    }

	.backBtn{width:80px;height:40px;position:absolute;right:20px;top:5px;z-index:99999;line-height:40px;text-align:center;font-size:16px;}
	.mapTcStyle {
		background: none !important;
		box-sizing: border-box;
		border-radius: 20px;
	}
  .tcNeiTitle {
    font-size: 22px;
    height: 50px;
    padding-top: 30px;
    font-weight: bold;
    color: #69f5ff;
  }

	.tcNeiTitle1 {
		font-size: 18px;
		color: #69f5ff;
    cursor: pointer;
	}

	.tcNeiBox .leftImage {
		width: 500px;
		height: 360px;
		padding: 10px;
		box-sizing: border-box;
		box-shadow: 0 0 20px inset #2281c4;
		;
	}

	.textInfo {
		height: 360px;
		width: 100%;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 1.9;
		overflow-y: auto;
		padding-right: 10px;
		box-sizing: border-box;
	}

	#mainSf {
		width: 100%;
		height: calc(100vh - 105px);
		position: relative;
	}

	#mainSf::before {
		position: absolute;
		content: '';
		width: 100%;
		height: 100%;
		background: url('../../assets/images/allBg.png') 20px 150px no-repeat;
		background-size: 100% 100%;
		bottom: 0;
		left: 0;
		opacity: 0.5;
	}

	.leftMessageBox {
		position: absolute;
		left: 20px;
		z-index: 999;
		bottom: 50px;
		width: 360px;
		height: 185px;
		background: url('../../assets/images/leftBox.png') center no-repeat;
		background-size: 100% 100%;
		padding: 22px 31px;
	}

	.circle {
		width: 780px;
		height: 780px;
		position: absolute;
		left: -30%;
		top: calc(50% - 390px);
		opacity: 0.5;
		transform: scale(0.7);
		-o-transform: rotate(0.7);
		-webkit-transform: rotate(0.7);
		-moz-transform: rotate(0.7);

	}

	.circle1 {
		width: 780px;
		height: 780px;
		background: url('../../assets/images/circle1.png')center no-repeat;
		background-size: 100% 100%;
		position: absolute;
		animation: myfirst 15s infinite linear;
		-webkit-animation: myfirst 15s infinite linear;
		/* Safari and Chrome */
	}

	.circle2 {
		width: 780px;
		height: 780px;
		background: url('../../assets/images/circle2.png')center no-repeat;
		background-size: 100% 100%;
		left: 0;
		top: 0;
		position: absolute;
		animation: myfirst2 15s infinite linear;
		-webkit-animation: myfirst2 15s infinite linear;
		/* Safari and Chrome */
	}

	.circle3 {
		width: 780px;
		height: 780px;
		background: url('../../assets/images/circle3.png')center no-repeat;
		background-size: 100% 100%;
		left: 0;
		top: 0;
		position: absolute;
		animation: myfirst 15s infinite linear;
		-webkit-animation: myfirst 15s infinite linear;
		/* Safari and Chrome */
	}

	.circle4 {
		width: 780px;
		height: 780px;
		background: url('../../assets/images/circle4.png')center no-repeat;
		background-size: 100% 100%;
		left: 0;
		top: 0;
		position: absolute;
		animation: myfirst2 15s infinite linear;
		-webkit-animation: myfirst2 15s infinite linear;
		/* Safari and Chrome */
	}

	.dateWeek {
		position: absolute;
		top: 0;
		left: 0;
		width: 200px;
		height: 50px;
		color: #ffffff;
	}

	.leftMessageBox .neiBox {
		box-shadow: 0 0 50px inset rgba(0, 151, 255, 1);
		height: 140px;
		border-radius: 20px;
		padding: 17px;
		box-sizing: border-box;
	}

	.baseBody {
		width: 100%;
		height: 100vh;
		background: #000208 url('../../assets/images/bg1.png') center no-repeat;
		background-size: 100% 100%;
		overflow: hidden;
	}

	.zwRightBox {
		width: 340px;
		height: calc(100vh - 0);
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		border-radius: 260px 0 0 160px/350px 0 0 300px;
		background: url('../../assets/images/leftBoxbg.png') center no-repeat;
		;
		background-size: 100% 100%;
		/* background: -webkit-linear-gradient(left, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* Safari 5.1 - 6.0 */
		/*  background: -o-linear-gradient(right, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* Opera 11.1 - 12.0 */
		/*  background: -moz-linear-gradient(right, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* Firefox 3.6 - 15 */
		/* background: linear-gradient(to right,rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* 标准的语法 */
	}

	.zwRightBoxLine {
		width: 2px;
		height: 200px;
	}

	.zwRightMneuItem {
		background: url('../../assets/images/btnNormal.png') center no-repeat;
		background-size: 100% 100%;
		width: 230px;
		height: 62px;
		line-height: 62px;
		cursor: pointer;
		transition: transform 0.5s;
		-webkit-transition: transform 0.5s;
		transform: scale(1);
		-webkit-transform: scale(1);
		/*兼容-webkit-引擎浏览器*/
		-moz-transform: scale(1);
	}

	.zwRightMneuItem:hover,.zwRightMneuItem.checked {
		background: url('../../assets/images/btnNormalChecked.png') center no-repeat;
		background-size: 100% 100%;
		cursor: pointer;
		transition: transform 0.5s;
		-webkit-transition: transform 0.5s;
		transform: scale(1.1);
		-webkit-transform: scale(1.1);
		/*兼容-webkit-引擎浏览器*/
		-moz-transform: scale(1.1);
	}

	.topHead {
		width: 100%;
		height: 103px;
	}

	.topHead .leftHead {
		width: 28%;
		height: 81px;
		background: url('../../assets/images/leftTop.png') center no-repeat;
		background-size: 100% 100%;
	}

	.topHead .midHead {
		width: 44%;
		height: 103px;
		background: url('../../assets/images/midTop.png') center no-repeat;
		background-size: 100% 100%;
		text-align: center;
		font-weight: bold;
		font-size: 38px;
		line-height: 93px;
		color: #FFFFFF;
	}

	.topHead .rightHead {
		width: 28%;
		height: 81px;
		background: url('../../assets/images/rightTop.png') center no-repeat;
		background-size: 100% 100%;
	}
	.textInfo img{max-width: 100%;height: auto;}
</style>
